export function BrandMark({ className }: { className?: string }) {
  return (
    <div className={className ?? "sp-brand-block"}>
      <img
        className="sp-brand-logo"
        src="/logo.png"
        alt=""
        width={80}
        height={80}
        decoding="async"
      />
      <div className="sp-brand-text">
        <p className="sp-brand-eyebrow">Secure vault</p>
        <h1 className="sp-brand brand">CipherNest</h1>
      </div>
    </div>
  );
}
